/** W82 Web-5b (K4, entscheide C3): Merker `pg-registriert` = `{ adresse, bis }` nach „Konto anlegen“, lokal, 48 h. Fordert man
 *  vor dem Bestätigen für genau diese Adresse einen Anmeldelink an, zeigt die Anmeldeseite wieder „Bestätige deine Adresse“.
 *  Das Wissen kommt nur aus diesem Browser, nie aus der Antwort des Servers (neutral, W13b). Der Merker fällt nach einer
 *  erfolgreichen Anmeldung und nach erfolgreichem Bestätigen. */
export const REGISTRIERT_MERKER = "pg-registriert";
const DAUER_MS = 48 * 60 * 60 * 1000;

const norm = (adresse: string) => adresse.trim().toLowerCase();

export function registriertMerken(adresse: string, jetzt = Date.now()): void {
  try {
    localStorage.setItem(REGISTRIERT_MERKER, JSON.stringify({ adresse: norm(adresse), bis: jetzt + DAUER_MS }));
  } catch {
    /* ohne Speicher sagt die Seite beim zu frühen Link nur den neutralen Satz */
  }
}

/** Gemerkte Adresse, solange der Merker gilt. Einen abgelaufenen oder unlesbaren nimmt sie weg: die Adresse liegt nicht
 *  länger in diesem Browser, als sie gebraucht wird (R1 W82-Web-5b). */
function lesen(jetzt: number): string | null {
  try {
    const roh = localStorage.getItem(REGISTRIERT_MERKER);
    if (!roh) return null;
    const m = JSON.parse(roh) as { adresse?: unknown; bis?: unknown };
    if (typeof m.adresse === "string" && typeof m.bis === "number" && m.bis > jetzt) return m.adresse;
  } catch {
    /* unlesbar: wie abgelaufen */
  }
  registriertVergessen();
  return null;
}

/** Ist `adresse` (getrimmt, klein) die gemerkte und der Merker nicht abgelaufen? */
export function registriertGleich(adresse: string, jetzt = Date.now()): boolean {
  return lesen(jetzt) === norm(adresse);
}

/** Beim Öffnen der Anmeldeseite: ein abgelaufener Merker fällt, auch wenn niemand mehr einen Link anfordert. */
export function registriertAufraeumen(jetzt = Date.now()): void {
  lesen(jetzt);
}

export function registriertVergessen(): void {
  try {
    localStorage.removeItem(REGISTRIERT_MERKER);
  } catch {
    /* nichts zu tun */
  }
}
